import React from 'react';

interface CheckoutLoadingProps {
  loading: Set<string>;
  shopifyOffer?: any;
  paymentErrorMessage?: string | null;
}

export const CheckoutLoading: React.FC<CheckoutLoadingProps> = ({ loading, shopifyOffer, paymentErrorMessage }) => {
  // ✅ Loading unificado - um único componente para todos os estados
  const handleCloseError = () => {
    try {
      // @ts-ignore - setter exposto via window em CheckoutPage
      if (typeof window !== 'undefined' && (window as any).setCheckoutPaymentErrorMessage) {
        // Limpa a mensagem para fechar o overlay
        (window as any).setCheckoutPaymentErrorMessage(null);
      }
    } catch {}
  };
  
  // Se não há shopifyOffer OU se há loading inicial, mostra loading
  if (!shopifyOffer || loading.has('initial')) {
    return (
      <>
        {/* Overlay de background */}
        <div><div className="fixed inset-0 bg-white/95 z-[9998]" />
        
        {/* Conteúdo do loading */}
        <div className="fixed inset-0 flex flex-col justify-center items-center z-[9999] p-4">
          <div className="w-[60px] h-[60px] border-4 border-orange-500/25 border-t-orange-500 rounded-full animate-spin mb-3" />
          <h2 className="font-bold text-gray-700 mb-2 text-center text-3xl">
            {!shopifyOffer ? 'Carregando...' : 'Aguarde...'}
          </h2>
          <p className="text-gray-500 text-center max-w-md leading-relaxed">
            {!shopifyOffer ? 'Aguarde enquanto preparamos seu checkout.' : 'Estamos processando seu pedido. Não feche esta tela.'}
          </p>
        </div>
        </div>
      </>
    );
  }

  // ✅ Loading para estados ativos (não 'initial')
  const hasPaymentError = Boolean(paymentErrorMessage);
  const activeLoadingStates = Array.from(loading).filter(state => state !== 'initial');
  if (activeLoadingStates.length === 0 && !hasPaymentError) return null;

  // Verifica se é loading de pagamento
  const isPaymentLoading = activeLoadingStates.includes('placeOrder') || hasPaymentError;

  return (
    <>
      {/* Overlay de background */}
      <div className="fixed inset-0 bg-white/95 z-[9998]" />
      
      {/* Conteúdo do loading */}
      <div className="fixed inset-0 flex flex-col justify-center items-center z-[9999] p-4">
        {hasPaymentError ? (
          <svg width="64" height="64" viewBox="0 0 24 24" aria-hidden="true" className="mb-3">
            <path fill="#ef4444" d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"/>
          </svg>
        ) : (
          <div className="w-[60px] h-[60px] border-4 border-orange-500/25 border-t-orange-500 rounded-full animate-spin mb-3" />
        )}
        
        {isPaymentLoading ? (
          <>
            <h2 className="font-bold text-gray-700 mb-2 text-center text-3xl">
              {hasPaymentError ? (paymentErrorMessage?.includes('\n') ? paymentErrorMessage.split('\n')[0] : 'Ocorreu um erro') : 'Aguarde...'}
            </h2>
            <p className="text-gray-500 text-center max-w-md leading-relaxed whitespace-pre-line">
              {hasPaymentError ? (paymentErrorMessage?.includes('\n') ? paymentErrorMessage.split('\n').slice(1).join('\n') : paymentErrorMessage) : 'Estamos processando seu pedido.\nNão feche esta tela.'}
            </p>
            {hasPaymentError && (
              <button 
                onClick={handleCloseError} 
                className="mt-4 px-4 py-2.5 rounded-lg border-0 cursor-pointer bg-red-500 text-white font-semibold hover:bg-red-600 transition-colors"
              >
                Fechar
              </button>
            )}
          </>
        ) : (
          <>
            <h2 className="font-bold text-gray-700 mb-1 text-center text-2xl">Processando...</h2>
            <p className="text-gray-500 text-center max-w-md">
              {activeLoadingStates.includes('applyCoupon') && 'Aplicando cupom...'}
              {activeLoadingStates.includes('saveSection') && 'Salvando informações...'}
              {activeLoadingStates.filter(state => !['applyCoupon', 'saveSection'].includes(state)).length > 0 && 'Carregando...'}
            </p>
          </>
        )}
      </div>
    </>
  );
}; 